// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ══════════════════════════════════════════════════════════════════
   레이아웃 — 헤더 · 드로어 · 푸터 · 플로팅
   ══════════════════════════════════════════════════════════════════ */

/* ── 헤더 ─────────────────────────────────────────── */
.hdr {
  position: sticky;
  top: 0;
  z-index: var(--z-header);
  height: var(--header-h);
  background: rgba(255, 255, 255, 0.86);
  backdrop-filter: saturate(160%) blur(10px);
  -webkit-backdrop-filter: saturate(160%) blur(10px);
  border-bottom: 1px solid transparent;
  transition: border-color var(--dur), box-shadow var(--dur);
}

.hdr.is-scrolled {
  border-bottom-color: var(--line-2);
  box-shadow: 0 6px 24px -18px rgba(12, 17, 24, 0.35);
}

.hdr-in {
  height: 100%;
  display: flex;
  align-items: center;
  gap: 20px;
}

.hdr-logo img {
  height: 40px;
  width: auto;
}

.hdr-nav {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-left: 20px;
}

.hdr-item {
  position: relative;
}

.hdr-link {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  height: 40px;
  padding: 0 13px;
  border-radius: var(--r-1);
  font-weight: 600;
  font-size: 14.5px;
  color: var(--ink-2);
  transition: color var(--dur), background var(--dur);
}

.hdr-link:hover,
.hdr-item.is-open .hdr-link,
.hdr-link.is-active {
  color: var(--ink);
  background: var(--surface-3);
}

.hdr-link.is-active {
  color: var(--brand);
  background: var(--brand-soft);
}

.hdr-link svg {
  transition: transform var(--dur);
}

.hdr-item.is-open .hdr-link svg {
  transform: rotate(180deg);
}

.hdr-drop {
  position: absolute;
  left: 0;
  top: calc(100% + 8px);
  min-width: 340px;
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: var(--r-3);
  box-shadow: var(--sh-3);
  padding: 8px;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-6px);
  transition: all var(--dur) var(--ease);
  z-index: var(--z-drop);
}

.hdr-item.is-open .hdr-drop {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.hdr-drop-item {
  display: grid;
  grid-template-columns: 44px 1fr 16px;
  gap: 12px;
  align-items: center;
  padding: 10px 12px;
  border-radius: var(--r-2);
  transition: background var(--dur);
}

.hdr-drop-item:hover {
  background: var(--surface-2);
}

.hdr-drop-item b {
  display: block;
  font-weight: 600;
  font-size: 14px;
  color: var(--ink);
}

.hdr-drop-item small {
  display: block;
  font-size: 12.5px;
  color: var(--ink-3);
  margin-top: 1px;
}

.hdr-drop-item .arrow {
  color: var(--ink-4);
  transition: transform var(--dur), color var(--dur);
}

.hdr-drop-item:hover .arrow {
  color: var(--brand);
  transform: translateX(2px);
}

.hdr-right {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 8px;
}

.hdr-ico,
.hdr-burger {
  width: 42px;
  height: 42px;
  border: 0;
  border-radius: var(--r-1);
  background: transparent;
  color: var(--ink-2);
  display: inline-grid;
  place-items: center;
}

.hdr-ico svg,
.hdr-burger svg {
  width: 21px;
  height: 21px;
}

.hdr-ico:hover:not(:disabled),
.hdr-burger:hover:not(:disabled) {
  background: var(--surface-3);
  color: var(--ink);
  border-color: transparent;
}

.hdr-bell {
  position: relative;
}

.hdr-badge {
  position: absolute;
  top: 3px;
  right: 3px;
  min-width: 17px;
  height: 17px;
  padding: 0 4px;
  border-radius: var(--r-pill);
  background: var(--spark);
  color: #fff;
  font-family: var(--f-m);
  font-size: 10px;
  font-weight: 600;
  display: grid;
  place-items: center;
  line-height: 1;
  border: 2px solid var(--surface);
}

.hdr-auth {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-left: 6px;
}

.hdr-user {
  position: relative;
  margin-left: 4px;
}

.hdr-user-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  height: 42px;
  padding: 0 10px 0 4px;
  border-radius: var(--r-pill);
  transition: background var(--dur);
}

.hdr-user-btn:hover {
  background: var(--surface-3);
}

.hdr-user-btn .avatar {
  width: 32px;
  height: 32px;
  font-size: 12.5px;
}

.hdr-user-name {
  font-weight: 600;
  font-size: 14px;
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.hdr-user-btn svg.rot {
  transform: rotate(180deg);
}

.hdr-user-menu {
  position: absolute;
  right: 0;
  top: calc(100% + 8px);
  width: 260px;
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: var(--r-3);
  box-shadow: var(--sh-3);
  padding: 8px;
  z-index: var(--z-drop);
  animation: rise 0.2s var(--ease-out) both;
}

.hdr-user-head {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 8px 4px;
}

.hdr-user-menu a,
.hdr-user-menu button {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 9px 10px;
  border-radius: var(--r-1);
  font-size: 14px;
  font-weight: 500;
  color: var(--ink-2);
  text-align: left;
  transition: background var(--dur), color var(--dur);
}

.hdr-user-menu a:hover,
.hdr-user-menu button:hover {
  background: var(--surface-2);
  color: var(--ink);
}

.hdr-user-menu button.danger:hover {
  background: var(--err-soft);
  color: var(--err);
}

.hdr-burger {
  display: none;
}

@media (max-width: 1024px) {
  .hdr-nav {
    display: none;
  }
  .hdr-auth,
  .hdr-user,
  .hdr-quote {
    display: none;
  }
  .hdr-burger {
    display: inline-grid;
  }
  .hdr-right {
    gap: 2px;
    margin-right: -8px; /* icon hit areas align with the gutter, glyphs sit inside it */
  }
  .hdr-ico,
  .hdr-burger {
    width: 44px;
    height: 44px;
  }
  .hdr-ico svg,
  .hdr-burger svg {
    width: 23px;
    height: 23px;
  }
  .hdr-badge {
    top: 4px;
    right: 4px;
  }
}

@media (max-width: 640px) {
  .hdr-logo img {
    height: 27px;
  }
}

/* ── 드로어 ───────────────────────────────────────── */
.drawer {
  position: fixed;
  inset: 0;
  z-index: var(--z-modal);
  visibility: hidden;
  pointer-events: none;
  overflow: hidden; /* 오프스크린 패널이 문서 폭을 넓히지 않게 */
}

.drawer.is-open {
  visibility: visible;
  pointer-events: auto;
}

.drawer-bg {
  position: absolute;
  inset: 0;
  background: rgba(12, 17, 24, 0.5);
  opacity: 0;
  transition: opacity 0.25s;
}

.drawer.is-open .drawer-bg {
  opacity: 1;
}

.drawer-panel {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: min(380px, 90vw);
  background: var(--surface);
  display: flex;
  flex-direction: column;
  transform: translateX(100%);
  transition: transform 0.32s var(--ease-out);
  box-shadow: var(--sh-3);
}

.drawer.is-open .drawer-panel {
  transform: translateX(0);
}

.drawer-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: var(--header-h);
  padding: 0 12px 0 var(--gutter);
  border-bottom: 1px solid var(--line-2);
}

.drawer-head .btn-icon {
  width: 44px;
  height: 44px;
  border: 0;
  background: transparent;
  color: var(--ink-2);
  display: inline-grid;
  place-items: center;
}

.drawer-head .btn-icon svg {
  width: 24px;
  height: 24px;
}

.drawer-head .btn-icon:hover:not(:disabled) {
  background: var(--surface-3);
  color: var(--ink);
  border-color: transparent;
}

.drawer-user {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 18px;
  background: var(--surface-2);
  border-bottom: 1px solid var(--line-2);
}

.drawer-user b,
.drawer-user small {
  display: block;
}

.drawer-user small {
  color: var(--ink-3);
  font-size: 12.5px;
}

.drawer-nav {
  padding: 8px 10px;
  overflow-y: auto;
  flex: 1 1;
}

.drawer-nav a {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 10px;
  border-radius: var(--r-1);
  font-weight: 600;
  font-size: 15px;
  color: var(--ink-2);
}

.drawer-nav a:hover,
.drawer-nav a.active {
  background: var(--surface-2);
  color: var(--ink);
}

.drawer-nav a.active {
  color: var(--brand);
}

.drawer-group {
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid var(--line-2);
}

.drawer-group .kicker {
  padding: 6px 10px;
}

.drawer-group a {
  font-weight: 500;
  padding: 10px;
}

.drawer-foot {
  padding: 14px 18px 18px;
  border-top: 1px solid var(--line-2);
  display: flex;
  flex-direction: column;
  gap: 10px;
}

/* ── 푸터 ─────────────────────────────────────────── */
.ftr {
  border-top: 1px solid var(--line-2);
  background: var(--surface-2);
  padding: 64px 0 28px;
  margin-top: 0;
}

.ftr-grid {
  display: grid;
  grid-template-columns: 1.6fr repeat(4, 1fr);
  gap: 32px;
}

.ftr-logo {
  height: 30px;
  width: auto;
}

.ftr-tag {
  margin-top: 16px;
  color: var(--ink-2);
  font-size: 14px;
  max-width: 34ch;
  line-height: 1.6;
}

.ftr-contact {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.ftr-contact li {
  display: flex;
  gap: 10px;
  font-size: 13px;
  color: var(--ink-3);
  line-height: 1.5;
}

.ftr-contact svg {
  flex: none;
  margin-top: 3px;
  color: var(--ink-4);
}

.ftr-contact a:hover {
  color: var(--brand);
}

.ftr-title {
  font-family: var(--f-m);
  font-size: 11px;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: var(--ink);
  font-weight: 600;
  margin-bottom: 14px;
}

.ftr-col li + li {
  margin-top: 8px;
}

.ftr-col a {
  display: inline-block;
  padding: 3px 0;
  min-height: 24px;
  font-size: 14px;
  color: var(--ink-2);
  transition: color var(--dur);
}

.ftr-col a:hover {
  color: var(--brand);
}

.ftr-bottom {
  margin-top: 48px;
  padding-top: 20px;
  border-top: 1px solid var(--line-2);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}

.ftr-copy {
  font-size: 11.5px;
  color: var(--ink-3);
  letter-spacing: 0.04em;
}

.ftr-meta {
  display: flex;
  align-items: center;
  gap: 16px;
  font-size: 13px;
  color: var(--ink-3);
}

.ftr-meta a {
  display: inline-block;
  padding: 4px 0;
}

.ftr-meta a:hover {
  color: var(--ink);
}

@media (max-width: 960px) {
  .ftr-grid {
    grid-template-columns: 1fr 1fr;
  }
  .ftr-brand {
    grid-column: span 2;
  }
}

@media (max-width: 480px) {
  .ftr-grid {
    grid-template-columns: 1fr;
  }
  .ftr-brand {
    grid-column: span 1;
  }
}

/* ── 플로팅 ───────────────────────────────────────── */
.floating {
  position: fixed;
  right: 22px;
  bottom: 22px;
  z-index: 40;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.floating-btn {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: var(--ink);
  color: #fff;
  display: grid;
  place-items: center;
  box-shadow: var(--sh-2);
  transition: transform var(--dur) var(--ease), opacity var(--dur), box-shadow var(--dur);
}

.floating-btn:hover {
  transform: translateY(-2px);
  box-shadow: var(--sh-3);
}

.floating-btn--brand {
  background: var(--brand);
}

.floating-btn.is-hidden {
  opacity: 0;
  pointer-events: none;
  transform: translateY(8px);
}

@media (max-width: 640px) {
  .floating {
    right: 14px;
    bottom: 14px;
  }
  .floating-btn {
    width: 42px;
    height: 42px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/layout/layout.css"],"names":[],"mappings":"AAAA;;uEAEuE;;AAEvE,sDAAsD;AACtD;EACE,gBAAgB;EAChB,MAAM;EACN,wBAAwB;EACxB,uBAAuB;EACvB,qCAAqC;EACrC,0CAA0C;EAC1C,kDAAkD;EAClD,oCAAoC;EACpC,0DAA0D;AAC5D;;AAEA;EACE,kCAAkC;EAClC,mDAAmD;AACrD;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,mDAAmD;AACrD;;AAEA;;;EAGE,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,qBAAqB;EACrB,gBAAgB;EAChB,0BAA0B;EAC1B,6BAA6B;EAC7B,yBAAyB;EACzB,uBAAuB;EACvB,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAC3B,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,kDAAkD;AACpD;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,yBAAyB;EACzB,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,4BAA4B;EAC5B,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,eAAe;EACf,YAAY;EACZ,cAAc;EACd,4BAA4B;EAC5B,wBAAwB;EACxB,WAAW;EACX,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,qBAAqB;EACrB,4BAA4B;EAC5B,iCAAiC;AACnC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,qBAAqB;EACrB,YAAY;EACZ,0BAA0B;EAC1B,6BAA6B;EAC7B,yBAAyB;EACzB,uBAAuB;EACvB,YAAY;EACZ,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,oBAAoB;AACtB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,mDAAmD;AACrD;;AAEA;;EAEE,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,aAAa;EACf;EACA;;;IAGE,aAAa;EACf;EACA;IACE,oBAAoB;EACtB;EACA;IACE,QAAQ;IACR,kBAAkB,EAAE,+DAA+D;EACrF;EACA;;IAEE,WAAW;IACX,YAAY;EACd;EACA;;IAEE,WAAW;IACX,YAAY;EACd;EACA;IACE,QAAQ;IACR,UAAU;EACZ;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA,qDAAqD;AACrD;EACE,eAAe;EACf,QAAQ;EACR,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB,EAAE,2BAA2B;AAC/C;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,iCAAiC;EACjC,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,uBAAuB;EACvB,0BAA0B;EAC1B,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,2CAA2C;EAC3C,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,+BAA+B;EAC/B,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,4BAA4B;EAC5B,sCAAsC;AACxC;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;;EAEE,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,mCAAmC;EACnC,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,sDAAsD;AACtD;EACE,mCAAmC;EACnC,4BAA4B;EAC5B,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,8BAA8B;EAChC;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA,qDAAqD;AACrD;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uFAAuF;AACzF;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,UAAU;EACV,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA;EACE;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":["/* ══════════════════════════════════════════════════════════════════\n   레이아웃 — 헤더 · 드로어 · 푸터 · 플로팅\n   ══════════════════════════════════════════════════════════════════ */\n\n/* ── 헤더 ─────────────────────────────────────────── */\n.hdr {\n  position: sticky;\n  top: 0;\n  z-index: var(--z-header);\n  height: var(--header-h);\n  background: rgba(255, 255, 255, 0.86);\n  backdrop-filter: saturate(160%) blur(10px);\n  -webkit-backdrop-filter: saturate(160%) blur(10px);\n  border-bottom: 1px solid transparent;\n  transition: border-color var(--dur), box-shadow var(--dur);\n}\n\n.hdr.is-scrolled {\n  border-bottom-color: var(--line-2);\n  box-shadow: 0 6px 24px -18px rgba(12, 17, 24, 0.35);\n}\n\n.hdr-in {\n  height: 100%;\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n\n.hdr-logo img {\n  height: 40px;\n  width: auto;\n}\n\n.hdr-nav {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  margin-left: 20px;\n}\n\n.hdr-item {\n  position: relative;\n}\n\n.hdr-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  height: 40px;\n  padding: 0 13px;\n  border-radius: var(--r-1);\n  font-weight: 600;\n  font-size: 14.5px;\n  color: var(--ink-2);\n  transition: color var(--dur), background var(--dur);\n}\n\n.hdr-link:hover,\n.hdr-item.is-open .hdr-link,\n.hdr-link.is-active {\n  color: var(--ink);\n  background: var(--surface-3);\n}\n\n.hdr-link.is-active {\n  color: var(--brand);\n  background: var(--brand-soft);\n}\n\n.hdr-link svg {\n  transition: transform var(--dur);\n}\n\n.hdr-item.is-open .hdr-link svg {\n  transform: rotate(180deg);\n}\n\n.hdr-drop {\n  position: absolute;\n  left: 0;\n  top: calc(100% + 8px);\n  min-width: 340px;\n  background: var(--surface);\n  border: 1px solid var(--line);\n  border-radius: var(--r-3);\n  box-shadow: var(--sh-3);\n  padding: 8px;\n  opacity: 0;\n  visibility: hidden;\n  transform: translateY(-6px);\n  transition: all var(--dur) var(--ease);\n  z-index: var(--z-drop);\n}\n\n.hdr-item.is-open .hdr-drop {\n  opacity: 1;\n  visibility: visible;\n  transform: translateY(0);\n}\n\n.hdr-drop-item {\n  display: grid;\n  grid-template-columns: 44px 1fr 16px;\n  gap: 12px;\n  align-items: center;\n  padding: 10px 12px;\n  border-radius: var(--r-2);\n  transition: background var(--dur);\n}\n\n.hdr-drop-item:hover {\n  background: var(--surface-2);\n}\n\n.hdr-drop-item b {\n  display: block;\n  font-weight: 600;\n  font-size: 14px;\n  color: var(--ink);\n}\n\n.hdr-drop-item small {\n  display: block;\n  font-size: 12.5px;\n  color: var(--ink-3);\n  margin-top: 1px;\n}\n\n.hdr-drop-item .arrow {\n  color: var(--ink-4);\n  transition: transform var(--dur), color var(--dur);\n}\n\n.hdr-drop-item:hover .arrow {\n  color: var(--brand);\n  transform: translateX(2px);\n}\n\n.hdr-right {\n  margin-left: auto;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.hdr-ico,\n.hdr-burger {\n  width: 42px;\n  height: 42px;\n  border: 0;\n  border-radius: var(--r-1);\n  background: transparent;\n  color: var(--ink-2);\n  display: inline-grid;\n  place-items: center;\n}\n\n.hdr-ico svg,\n.hdr-burger svg {\n  width: 21px;\n  height: 21px;\n}\n\n.hdr-ico:hover:not(:disabled),\n.hdr-burger:hover:not(:disabled) {\n  background: var(--surface-3);\n  color: var(--ink);\n  border-color: transparent;\n}\n\n.hdr-bell {\n  position: relative;\n}\n\n.hdr-badge {\n  position: absolute;\n  top: 3px;\n  right: 3px;\n  min-width: 17px;\n  height: 17px;\n  padding: 0 4px;\n  border-radius: var(--r-pill);\n  background: var(--spark);\n  color: #fff;\n  font-family: var(--f-m);\n  font-size: 10px;\n  font-weight: 600;\n  display: grid;\n  place-items: center;\n  line-height: 1;\n  border: 2px solid var(--surface);\n}\n\n.hdr-auth {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-left: 6px;\n}\n\n.hdr-user {\n  position: relative;\n  margin-left: 4px;\n}\n\n.hdr-user-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  height: 42px;\n  padding: 0 10px 0 4px;\n  border-radius: var(--r-pill);\n  transition: background var(--dur);\n}\n\n.hdr-user-btn:hover {\n  background: var(--surface-3);\n}\n\n.hdr-user-btn .avatar {\n  width: 32px;\n  height: 32px;\n  font-size: 12.5px;\n}\n\n.hdr-user-name {\n  font-weight: 600;\n  font-size: 14px;\n  max-width: 120px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.hdr-user-btn svg.rot {\n  transform: rotate(180deg);\n}\n\n.hdr-user-menu {\n  position: absolute;\n  right: 0;\n  top: calc(100% + 8px);\n  width: 260px;\n  background: var(--surface);\n  border: 1px solid var(--line);\n  border-radius: var(--r-3);\n  box-shadow: var(--sh-3);\n  padding: 8px;\n  z-index: var(--z-drop);\n  animation: rise 0.2s var(--ease-out) both;\n}\n\n.hdr-user-head {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 8px 4px;\n}\n\n.hdr-user-menu a,\n.hdr-user-menu button {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  padding: 9px 10px;\n  border-radius: var(--r-1);\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--ink-2);\n  text-align: left;\n  transition: background var(--dur), color var(--dur);\n}\n\n.hdr-user-menu a:hover,\n.hdr-user-menu button:hover {\n  background: var(--surface-2);\n  color: var(--ink);\n}\n\n.hdr-user-menu button.danger:hover {\n  background: var(--err-soft);\n  color: var(--err);\n}\n\n.hdr-burger {\n  display: none;\n}\n\n@media (max-width: 1024px) {\n  .hdr-nav {\n    display: none;\n  }\n  .hdr-auth,\n  .hdr-user,\n  .hdr-quote {\n    display: none;\n  }\n  .hdr-burger {\n    display: inline-grid;\n  }\n  .hdr-right {\n    gap: 2px;\n    margin-right: -8px; /* icon hit areas align with the gutter, glyphs sit inside it */\n  }\n  .hdr-ico,\n  .hdr-burger {\n    width: 44px;\n    height: 44px;\n  }\n  .hdr-ico svg,\n  .hdr-burger svg {\n    width: 23px;\n    height: 23px;\n  }\n  .hdr-badge {\n    top: 4px;\n    right: 4px;\n  }\n}\n\n@media (max-width: 640px) {\n  .hdr-logo img {\n    height: 27px;\n  }\n}\n\n/* ── 드로어 ───────────────────────────────────────── */\n.drawer {\n  position: fixed;\n  inset: 0;\n  z-index: var(--z-modal);\n  visibility: hidden;\n  pointer-events: none;\n  overflow: hidden; /* 오프스크린 패널이 문서 폭을 넓히지 않게 */\n}\n\n.drawer.is-open {\n  visibility: visible;\n  pointer-events: auto;\n}\n\n.drawer-bg {\n  position: absolute;\n  inset: 0;\n  background: rgba(12, 17, 24, 0.5);\n  opacity: 0;\n  transition: opacity 0.25s;\n}\n\n.drawer.is-open .drawer-bg {\n  opacity: 1;\n}\n\n.drawer-panel {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  width: min(380px, 90vw);\n  background: var(--surface);\n  display: flex;\n  flex-direction: column;\n  transform: translateX(100%);\n  transition: transform 0.32s var(--ease-out);\n  box-shadow: var(--sh-3);\n}\n\n.drawer.is-open .drawer-panel {\n  transform: translateX(0);\n}\n\n.drawer-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: var(--header-h);\n  padding: 0 12px 0 var(--gutter);\n  border-bottom: 1px solid var(--line-2);\n}\n\n.drawer-head .btn-icon {\n  width: 44px;\n  height: 44px;\n  border: 0;\n  background: transparent;\n  color: var(--ink-2);\n  display: inline-grid;\n  place-items: center;\n}\n\n.drawer-head .btn-icon svg {\n  width: 24px;\n  height: 24px;\n}\n\n.drawer-head .btn-icon:hover:not(:disabled) {\n  background: var(--surface-3);\n  color: var(--ink);\n  border-color: transparent;\n}\n\n.drawer-user {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 14px 18px;\n  background: var(--surface-2);\n  border-bottom: 1px solid var(--line-2);\n}\n\n.drawer-user b,\n.drawer-user small {\n  display: block;\n}\n\n.drawer-user small {\n  color: var(--ink-3);\n  font-size: 12.5px;\n}\n\n.drawer-nav {\n  padding: 8px 10px;\n  overflow-y: auto;\n  flex: 1;\n}\n\n.drawer-nav a {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 10px;\n  border-radius: var(--r-1);\n  font-weight: 600;\n  font-size: 15px;\n  color: var(--ink-2);\n}\n\n.drawer-nav a:hover,\n.drawer-nav a.active {\n  background: var(--surface-2);\n  color: var(--ink);\n}\n\n.drawer-nav a.active {\n  color: var(--brand);\n}\n\n.drawer-group {\n  margin-top: 10px;\n  padding-top: 10px;\n  border-top: 1px solid var(--line-2);\n}\n\n.drawer-group .kicker {\n  padding: 6px 10px;\n}\n\n.drawer-group a {\n  font-weight: 500;\n  padding: 10px;\n}\n\n.drawer-foot {\n  padding: 14px 18px 18px;\n  border-top: 1px solid var(--line-2);\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n/* ── 푸터 ─────────────────────────────────────────── */\n.ftr {\n  border-top: 1px solid var(--line-2);\n  background: var(--surface-2);\n  padding: 64px 0 28px;\n  margin-top: 0;\n}\n\n.ftr-grid {\n  display: grid;\n  grid-template-columns: 1.6fr repeat(4, 1fr);\n  gap: 32px;\n}\n\n.ftr-logo {\n  height: 30px;\n  width: auto;\n}\n\n.ftr-tag {\n  margin-top: 16px;\n  color: var(--ink-2);\n  font-size: 14px;\n  max-width: 34ch;\n  line-height: 1.6;\n}\n\n.ftr-contact {\n  margin-top: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.ftr-contact li {\n  display: flex;\n  gap: 10px;\n  font-size: 13px;\n  color: var(--ink-3);\n  line-height: 1.5;\n}\n\n.ftr-contact svg {\n  flex: none;\n  margin-top: 3px;\n  color: var(--ink-4);\n}\n\n.ftr-contact a:hover {\n  color: var(--brand);\n}\n\n.ftr-title {\n  font-family: var(--f-m);\n  font-size: 11px;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  color: var(--ink);\n  font-weight: 600;\n  margin-bottom: 14px;\n}\n\n.ftr-col li + li {\n  margin-top: 8px;\n}\n\n.ftr-col a {\n  display: inline-block;\n  padding: 3px 0;\n  min-height: 24px;\n  font-size: 14px;\n  color: var(--ink-2);\n  transition: color var(--dur);\n}\n\n.ftr-col a:hover {\n  color: var(--brand);\n}\n\n.ftr-bottom {\n  margin-top: 48px;\n  padding-top: 20px;\n  border-top: 1px solid var(--line-2);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.ftr-copy {\n  font-size: 11.5px;\n  color: var(--ink-3);\n  letter-spacing: 0.04em;\n}\n\n.ftr-meta {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  font-size: 13px;\n  color: var(--ink-3);\n}\n\n.ftr-meta a {\n  display: inline-block;\n  padding: 4px 0;\n}\n\n.ftr-meta a:hover {\n  color: var(--ink);\n}\n\n@media (max-width: 960px) {\n  .ftr-grid {\n    grid-template-columns: 1fr 1fr;\n  }\n  .ftr-brand {\n    grid-column: span 2;\n  }\n}\n\n@media (max-width: 480px) {\n  .ftr-grid {\n    grid-template-columns: 1fr;\n  }\n  .ftr-brand {\n    grid-column: span 1;\n  }\n}\n\n/* ── 플로팅 ───────────────────────────────────────── */\n.floating {\n  position: fixed;\n  right: 22px;\n  bottom: 22px;\n  z-index: 40;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.floating-btn {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  background: var(--ink);\n  color: #fff;\n  display: grid;\n  place-items: center;\n  box-shadow: var(--sh-2);\n  transition: transform var(--dur) var(--ease), opacity var(--dur), box-shadow var(--dur);\n}\n\n.floating-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--sh-3);\n}\n\n.floating-btn--brand {\n  background: var(--brand);\n}\n\n.floating-btn.is-hidden {\n  opacity: 0;\n  pointer-events: none;\n  transform: translateY(8px);\n}\n\n@media (max-width: 640px) {\n  .floating {\n    right: 14px;\n    bottom: 14px;\n  }\n  .floating-btn {\n    width: 42px;\n    height: 42px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
